import { createBrowserHistory } from 'history'
import config from 'config'

const history = createBrowserHistory()

const hasQueryParams = (url) => {
  return url && url.includes('?')
}

export const redirectToPage = (page, isNative = false, backNavigation = false) => {
  let backParam = ''

  if (backNavigation) {
    if (hasQueryParams(page)) {
      backParam = `&backNavigation=true`
    } else {
      backParam = `?backNavigation=true`
    }
  }

  if (isNative) {
    if (page.match(/home\/group/)) localStorage.removeItem('lastActiveTab')
    window.location = `${config.webUrl}${page}${backParam}`
    return
  }

  history.push(page, { backNavigation })
}

export const redirectToBack = (isNative = false) => {
  if (isNative) {
    const pathname = history.location.pathname
    if (pathname.match(/home\/group/)) localStorage.removeItem('lastActiveTab')
    return (window.location = `${config.webUrl}/?goBack=true`)
  }
  history.goBack()
}

export const historyReplaceState = (path = '', title = '', page = '') => {
  return window.history.replaceState(page, title, path)
}

export const historyPushState = (param = '', value = '') => {
  const currentURL = window.location.href
  let url = new URL(currentURL)
  if (param && value) {
    url.searchParams.set(param, value)
  } else if (param) {
    url.searchParams.delete(param)
  }
  historyReplaceState(url.toString())
}

export default history
